(function(){
  function money(c){return '$'+Math.round(c/100).toLocaleString('en-NZ');}
  function short(v){
    var m=v.match(/^([\d.]+)\s*US/i); if(m) return 'US '+m[1];
    var map=[[/^XXX Large$/i,'3XL'],[/^XX Large$/i,'XXL'],[/^X Large$/i,'XL'],[/^Large$/i,'L'],[/^Medium$/i,'M'],[/^X Small$/i,'XS'],[/^XX Small$/i,'XXS'],[/^Small$/i,'S']];
    for(var i=0;i<map.length;i++){ if(map[i][0].test(v)) return map[i][1]; }
    return v;
  }
  function parts(v){
    var y=v.replace(/\s*\(Yeezy\)\s*$/i,'');
    var m=y.match(/^([\d.]+)\s*Men[’']?s\s*\(\s*([\d.]+)\s*Women[’']?s\s*\)$/i);
    if(m) return {s:'US '+m[1], w:'Wmns '+m[2]};
    m=y.match(/^([\d.]+)\s*Y\s*\(\s*([\d.]+)\s*Women[’']?s\s*\)\s*(?:\((.+)\))?$/i);
    if(m) return {s:m[1]+'Y', w:'Wmns '+m[2]+(m[3]?' · '+m[3]:'')};
    m=y.match(/^([\d.]+)\s*C\s*\(\s*([\d.]+)\s*cm\s*\)$/i);
    if(m) return {s:m[1]+'C', w:m[2]+'cm'};
    return {s:short(y), w:''};
  }
  function productData(){
    var els=document.querySelectorAll('[data-section-data]');
    for(var i=0;i<els.length;i++){ try{ var j=JSON.parse(els[i].textContent); if(j && j.product && j.product.variants) return j.product; }catch(e){} }
    return null;
  }
  function sizeLabels(){
    var p=productData(); if(!p || !p.options || p.options.length!==1) return;
    var byVal={}; p.variants.forEach(function(v){ byVal[v.option1]=v; });
    var opts=document.querySelectorAll('.product_section .swatch__option');
    opts.forEach(function(w){
      var inp=w.querySelector('input[data-variant-option-value]'); var lab=w.querySelector('label[data-variant-option-value-label]');
      if(!inp||!lab||lab.getAttribute('data-iyw')) return;
      var v=byVal[inp.value]; if(!v) return;
      lab.setAttribute('data-iyw','1');
      var cross=lab.querySelector('.crossed-out');
      var s=parts(inp.value);
      lab.innerHTML='<span class="iyw-sz">'+s.s+'</span>'+(s.w?'<small class="iyw-szw">'+s.w+'</small>':'')+'<small class="iyw-szp">'+(v.available?money(v.price):'Sold out')+'</small>';
      if(cross) lab.appendChild(cross);
      w.setAttribute('title', inp.value);
    });
  }
  var SEL=/([\d.]+)\s*Men[’']?s\s*\(\s*([\d.]+)\s*Women[’']?s\s*\)(\s*\(Yeezy\))?/i;
  var SELY=/([\d.]+)\s*Y\s*\(\s*([\d.]+)\s*Women[’']?s\s*\)/i;
  function tidyText(root){
    var tw=document.createTreeWalker(root,4), n;
    while((n=tw.nextNode())){
      if(SEL.test(n.nodeValue)) n.nodeValue=n.nodeValue.replace(SEL,'US $1 (Wmns $2)');
      if(SELY.test(n.nodeValue)) n.nodeValue=n.nodeValue.replace(SELY,'$1Y (Wmns $2)');
    }
  }
  function chosenLabel(){
    document.querySelectorAll('.product_section .options-selection__option-name').forEach(function(el){
      tidyText(el);
      if(el.getAttribute('data-iyw-obs') || !window.MutationObserver) return;
      el.setAttribute('data-iyw-obs','1');
      new MutationObserver(function(){ tidyText(el); }).observe(el,{childList:true,subtree:true,characterData:true});
    });
  }

  /* prominent search: header search icons jump to the main search bar; shorter placeholder on phones */
  function searchBar(){
    var inp=document.querySelector('.iyw-chips .iyw-search input[name=q]');
    if(!inp || inp.getAttribute('data-iyw-s')) return;
    inp.setAttribute('data-iyw-s','1');
    var shortPh=inp.getAttribute('data-short-placeholder');
    function ph(){ if(!shortPh) return; if(!inp._full) inp._full=inp.placeholder; inp.placeholder=window.innerWidth<750?shortPh:inp._full; }
    ph(); window.addEventListener('resize', ph);
    window.addEventListener('click', function(e){
      var t=e.target && e.target.closest ? e.target.closest('[data-show-search-trigger]') : null;
      if(!t) return;
      e.preventDefault(); e.stopImmediatePropagation();
      try{ inp.focus({preventScroll:true}); }catch(err){ inp.focus(); }
      window.scrollTo({top:0, behavior:'smooth'});
    }, true);
  }
  function init(){ sizeLabels(); chosenLabel(); searchBar(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  window.addEventListener('load', init);
  setTimeout(init, 1500);
})();
